<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <!-- КУДА ИМЕННО ВЕРНЁТСЯ — СКАЗАНО ЗАРАНЕЕ. Правило решает держатель,
                     и человек должен видеть результат до нажатия, а не узнавать его
                     из карточки после. -->
                <p class="inventory-action-modal__hint">
                    <template v-if="holderName">
                        Оборудование вернётся в работу к <strong>{{ holderName }}</strong> — статус станет «В
                        эксплуатации».
                    </template>

                    <template v-else> Оборудование вернётся на склад: ответственного у него нет. </template>
                </p>

                <ValidationProvider class="active-form__field" name="repair-return-comment" v-slot="{ errors }">
                    <label class="active-form__label" for="repair-return-comment">Комментарий</label>

                    <VInput
                        id="repair-return-comment"
                        name="repair-return-comment"
                        class="active-form__control"
                        placeholder="Например: заменили клавиатуру"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green" :disabled="isSaving">
                        {{ isSaving ? 'Сохраняем…' : 'Вернуть из ремонта' }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { returnInventoryItemFromRepair } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Возврат оборудования из ремонта (7-F2B).
 *
 * КУДА ВЕРНЁТСЯ — РЕШАЕТ ДЕРЖАТЕЛЬ, и решает это сервер: держатель есть — «В эксплуатации»,
 * держателя нет — «На складе». С формы выбор не приходит, и выбирать здесь нечего;
 * окно лишь называет результат заранее, чтобы он не оказался неожиданностью.
 *
 * Комментарий необязателен: что сделали в сервисе, пишут не всегда, а обязательное поле
 * заполняют точкой.
 */
@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemRepairReturnModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_REPAIR_RETURN })
    name;
    @Prop({ type: String, default: 'Возврат из ремонта' })
    defaultTitle;

    itemId = null;
    holderName = '';
    comment = '';
    error = '';
    isSaving = false;

    async submit() {
        if (this.isSaving || !this.itemId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        try {
            const response = await returnInventoryItemFromRepair(this.itemId, { comment: this.comment });

            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        this.holderName = params.holderName || '';
        this.comment = '';
        this.error = '';
        this.isSaving = false;
    }

    beforeClose() {
        this.itemId = null;
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemRepairReturnModal;
</script>
